<template>
  <div>
    <v-row
      v-for="part in form.parts"
      :key="part.id"
      class="ma-1"
    >
      <v-col class="text--primary my-0" cols="2">
        <div class="text--primary">{{ $t(partTranslationKey + '.name') }}</div>
        <div>{{part.name}}</div>
      </v-col>
      <v-col class="my-0" cols="2">
        <v-text-field
          v-model="part.variationRatio"
          :label="$t('part.ratio')"
          outlined
          dense
          type="number"
          @input="handleVariationRatioChange"
          append-icon="mdi-percent-outline"
        />
      </v-col>
      <v-col class="my-0" v-if="!onlyAgreedValue">
        <div class="text--primary">{{ $t('variation.estimatedValue') }}</div>
        <div>{{ part.estimatedValueCents | formatCurrency({ key: part.currency, value: 1 }) }}</div>
      </v-col>
      <v-col class="my-0" v-if="!onlyEstimatedValue && !onlyAgreedValue">
        <div class="text--primary">{{ $t('variation.originalValue') }}</div>
        <div>{{ part.originalValueCents | formatCurrency({ key: part.currency, value: 1 }) }}</div>
      </v-col>
      <v-col class="my-0" v-if="!onlyEstimatedValue">
        <div class="text--primary">{{ $t('variation.agreedValue') }}</div>
        <div>{{ part.agreedValueCents | formatCurrency({ key: part.currency, value: 1 }) }}</div>
      </v-col>
      <v-col class="my-0" v-if="!onlyEstimatedValue && !onlyAgreedValue">
        <div class="text--primary">{{ $t(`variation.eotRequested.${reporter}`) }}</div>
        <div>{{ part.eotRequested }}</div>
      </v-col>
      <v-col class="my-0" v-if="!onlyEstimatedValue && !onlyAgreedValue">
        <div class="text--primary">{{ $t(`variation.eotAgreed.${reporter}`) }}</div>
        <div>{{ part.eotAgreed }}</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getLocalizationContext } from '@/helpers/translations'
import _ from 'lodash'

export default {
  name: 'RationsForParts',
  props: {
    form: Object,
    reporter: String,
    type: String
  },
  data () {
    return {
      initialForm: _.cloneDeep(this.form),
      dirty: false
    }
  },
  methods: {
    handleVariationRatioChange () {
      if (!this.dirty) {
        this.checkForDirtyness()
      }
      this.$emit('calculate')
    },
    checkForDirtyness () {
      const isDirty = !_.isEqual(this.initialForm, this.form)
      this.dirty = isDirty
      this.$emit('dirty', this.dirty)
    }
  },
  computed: {
    onlyEstimatedValue () {
      return this.type === 'early_warning'
    },
    onlyAgreedValue () {
      return this.type === 'amendment'
    },
    partTranslationKey () {
      return getLocalizationContext(this.form.isMultiCurrency)
    }
  }
}
</script>
